import { render, staticRenderFns } from "./superBros.vue?vue&type=template&id=011ab6a6"
import script from "./superBros.vue?vue&type=script&lang=js"
export * from "./superBros.vue?vue&type=script&lang=js"
import style0 from "./superBros.vue?vue&type=style&index=0&id=011ab6a6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports